<template>
  <div>
    <el-row class="title-table">
      <el-col :span="12">
        <h4>기간 내 접속자 수 그래프</h4>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="end">
          <w-datetime-range-button></w-datetime-range-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="mr-b30" type="flex">
      <el-col :span="18">
        <w-user-login-line-chart ref="userLineChart" :max-login-count.sync="maxLoginCount" :most-login-count.sync="mostLoginCount" :session-time-string.sync="sessionTimeString" @load-data="loadData"></w-user-login-line-chart>
      </el-col>
      <el-col :span="6" style="display:flex;">
        <el-row class="form-list" type="flex" align="middle" style="width:100%;">
          <el-form ref="form" label-position="left">
            <el-form-item label="최다 접속자 수" label-width="100px">{{maxLoginCount}}</el-form-item>
            <el-form-item label="최장 기간 접속자" label-width="100px">{{sessionTimeString}}</el-form-item>
            <el-form-item label="최다 로그인 접속자" label-width="100px">{{mostLoginCount}}</el-form-item>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <w-user-access-common-table ref="userAccessTable" active-tab="userLoginHist" :target-table="targetTable"
        :target-table-data="userLoginHistData" :total="total" @load-data="loadData"></w-user-access-common-table>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import UserAccessHistApi from '@/api/settings/user/user-access-hist';
import WUserLoginLineChart from './components/UserLoginLineChart';
import WUserAccessCommonTable from './components/UserAccessCommonTable';

export default {
  name: 'WUserLoginHist',
  components: { WUserLoginLineChart, WUserAccessCommonTable, WDatetimeRangeButton },
  props: {
    activeTab: {
      type: String,
    },
  },
  // computed: mapGetters(['analysisDateParams']),
  computed: {
    ...mapGetters(['analysisDateParams', 'isRelativeAnalysisDate']),
  },
  data() {
    return {
      showSearchTool: false,
      userLoginHistData: [],
      maxLoginCount: '-',
      mostLoginCount: '-',
      sessionTimeString: '-',
      total: 0,
      tableParams: {},
      targetTable: 'userLoginHist',
    };
  },
  methods: {
    loadData(item, tableParams) {
      if (!isEmpty(tableParams)) {
        this.tableParams = tableParams;
      }
      const params = {
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        ...this.tableParams,
      };
      // 사용자 접근이력 > 로그인/로그아웃 이력 조회
      UserAccessHistApi.getUserLoginHist(params).then((response) => {
        if (response.data.success) {
          this.userLoginHistData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserAccessHist/UserLoginHist.vue